import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, CardMedia, Paper } from '@mui/material';
import hdfc from '../assets/images/hdfc.jpg';
import idfc from '../assets/images/idfc.png';
import crifhighmark from '../assets/images/crifhighmark.png';
import PageTitle from '../components/PageTitle';

const partners = [
  {
    name: 'HDFC Bank',
    description: 'A leading organization in financial services, supporting community development initiatives.',
    logo: hdfc, // Corrected logo path
  },
  {
    name: 'IDFC First Bank',
    description: 'An innovative company providing technology solutions for financial inclusion.',
    logo: idfc, // Corrected logo path
  },
  {
    name: 'CRIF High Mark',
    description: 'A global nonprofit organization dedicated to empowering underserved communities.',
    logo: crifhighmark, // Corrected logo path
  },
   
];

const Partners = () => {
  return (
    <>
      <PageTitle title="Our Partners" />
      <Box sx={{ bgcolor: 'background.default', py: 6 }}>
        <Container maxWidth="lg">
          <Paper elevation={3} sx={{ p: 4, borderRadius: 2, mb: 4 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
              Our Partners
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, textAlign: 'center', color: 'text.secondary' }}>
              We are proud to collaborate with esteemed organizations that share our vision of empowering communities through financial inclusion.
            </Typography>
          </Paper>
          <Grid container spacing={4}>
            {partners.map((partner, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: 3,
                    borderRadius: 2,
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: 5,
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    image={partner.logo} // Use the corrected logo path
                    alt={partner.name}
                    sx={{
                      height: 140,
                      objectFit: 'contain',
                      bgcolor: 'grey.100',
                      p: 2,
                    }}
                  />
                  <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                      {partner.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      {partner.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Partners;
